import React, { useState } from 'react';
import { Modal, SearchableSelect } from '../../components/ui';
import { errMsg } from '../../utils/format';
import { useFetch } from '../../hooks/useFetch';
import api from '../../utils/api';

export default function AddKitModal({ onClose, onSaved }) {
  const { data: products } = useFetch('/api/products');
  const [form, setForm] = useState({ name:'', sku:'', shopifyProductId:'', amazonAsin:'' });
  const [components, setComponents] = useState([{ productId:'', quantity:'1' }]);
  const [saving, setSaving] = useState(false);

  const addComponent = () => setComponents(c => [...c, { productId:'', quantity:'1' }]);
  const removeComponent = (idx) => setComponents(c => c.filter((_,j)=>j!==idx));
  const setComponent = (idx,k,v) => setComponents(c => c.map((row,j)=>j===idx?{...row,[k]:v}:row));
  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  const productOptions = (products||[]).map(p => ({ value: p.id, label: `${p.sku} — ${p.name}` }));

  const save = async (e) => {
    e.preventDefault();
    const valid = components.filter(c=>c.productId && c.quantity);
    if (!valid.length) { alert('Add at least one component'); return; }
    setSaving(true);
    try {
      await api.post('/api/kits', {
        ...form,
        components: valid.map(c=>({ productId:parseInt(c.productId), quantity:parseInt(c.quantity) }))
      });
      onSaved('Kit created successfully'); onClose();
    } catch(err) { alert(errMsg(err)); }
    finally { setSaving(false); }
  };

  return (
    <Modal title="New Kit / Bundle" onClose={onClose} wide
      footer={<><button className="btn" onClick={onClose}>Cancel</button><button className="btn btn-primary" form="add-kit-form" type="submit">{saving?'Saving…':'Create kit'}</button></>}>
      <form id="add-kit-form" onSubmit={save}>
        <div className="form-row">
          <div className="form-group"><label>Kit name *</label><input required value={form.name} onChange={e=>set('name',e.target.value)} /></div>
          <div className="form-group"><label>SKU *</label><input required value={form.sku} onChange={e=>set('sku',e.target.value)} /></div>
        </div>
        <div className="form-row">
          <div className="form-group"><label>Shopify Product ID</label><input value={form.shopifyProductId} onChange={e=>set('shopifyProductId',e.target.value)} placeholder="Optional" /></div>
          <div className="form-group"><label>Amazon ASIN</label><input value={form.amazonAsin} onChange={e=>set('amazonAsin',e.target.value)} placeholder="Optional" /></div>
        </div>
        <div style={{ fontWeight:500, fontSize:13, marginBottom:8, marginTop:16 }}>Components</div>
        {components.map((comp,idx) => (
          <div key={idx} style={{ display:'grid', gridTemplateColumns:'3fr 1fr auto', gap:8, marginBottom:8, alignItems:'end' }}>
            <div className="form-group" style={{ margin:0 }}>
              {idx===0 && <label style={{ fontSize:11 }}>Finished good</label>}
              <SearchableSelect
                value={comp.productId}
                onChange={v => setComponent(idx,'productId',v)}
                options={productOptions}
                placeholder="— Search or select product —"
              />
            </div>
            <div className="form-group" style={{ margin:0 }}>
              {idx===0 && <label style={{ fontSize:11 }}>Qty per kit</label>}
              <input type="number" min="1" value={comp.quantity} onChange={e=>setComponent(idx,'quantity',e.target.value)} />
            </div>
            <button type="button" className="btn btn-sm btn-danger" style={{ marginTop:idx===0?18:0 }} onClick={()=>removeComponent(idx)}>
              <i className="ti ti-x" />
            </button>
          </div>
        ))}
        <button type="button" className="btn btn-sm" onClick={addComponent} style={{ marginTop:4 }}>
          <i className="ti ti-plus" /> Add component
        </button>
      </form>
    </Modal>
  );
}
